// Reconstructed from the supplied production build; original component names were unavailable.
import { React, jsxRuntime, useNavigate } from "../../vendor/runtime.js";
import { useAuth } from "../../context/AuthContext.jsx";
import { VerifyOtpInput } from "./VerifyOtpInput.jsx";
const VerifyEmailForm = ({ userId: a, email: n }) => {
  const [i, l] = React.useState(""),
    [c, u] = React.useState(""),
    [m, f] = React.useState(false),
    [x, p] = React.useState(false),
    [g, b] = React.useState(0),
    [y, w] = React.useState(false),
    { verifyEmail: N, resendOTP: T } = useAuth(),
    C = useNavigate();
  React.useEffect(() => {
    let Y;
    return (g > 0 && (Y = setTimeout(() => b(g - 1), 1e3)), () => clearTimeout(Y));
  }, [g]);
  const A = async (Y) => {
      if ((Y.preventDefault(), !i || i.length !== 6)) {
        u("Please enter the complete 6-digit verification code");
        return;
      }
      (f(true), u(""));
      try {
        (await N(a, i)).success &&
          (w(true),
          setTimeout(() => {
            C("/login", {
              state: {
                verificationSuccess: true,
              },
            });
          }, 2e3));
      } catch (R) {
        (console.error("Verification error:", R),
          u(R.message || "Invalid verification code. Please try again."));
      } finally {
        f(false);
      }
    },
    O = async () => {
      if (!(g > 0)) {
        (p(true), u(""));
        try {
          (await T(n)).success && (b(60), l(""));
        } catch (Y) {
          (console.error("Resend OTP error:", Y),
            u(Y.message || "Failed to resend verification code"));
        } finally {
          p(false);
        }
      }
    },
    M = (Y) => {
      const [R, U] = Y.split("@");
      return `${R.length > 2 ? R.substring(0, 2) + "*".repeat(R.length - 2) : R}@${U}`;
    };
  return y ? (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4"
      }
    >
      <div
        className={
          "bg-white rounded-xl sm:rounded-2xl shadow-2xl p-4 sm:p-8 md:p-10 w-full max-w-sm sm:max-w-md mx-auto"
        }
      >
        <div className={"text-center"}>
          <div
            className={
              "mx-auto w-12 h-12 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mb-4 sm:mb-6"
            }
          >
            <svg
              className={"w-6 h-6 sm:w-10 sm:h-10 text-green-600"}
              fill={"none"}
              stroke={"currentColor"}
              viewBox={"0 0 24 24"}
            >
              <path
                strokeLinecap={"round"}
                strokeLinejoin={"round"}
                strokeWidth={"3"}
                d={"M5 13l4 4L19 7"}
              />
            </svg>
          </div>
          <h2 className={"text-lg sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-3"}>
            {"Email Verified!"}
          </h2>
          <p className={"text-gray-600 text-xs sm:text-base mb-4 sm:mb-6 leading-relaxed"}>
            {"Your email has been successfully verified. You'll be redirected to login shortly."}
          </p>
          <div className={"flex items-center justify-center"}>
            <svg
              className={"animate-spin -ml-1 mr-3 h-4 w-4 sm:h-5 sm:w-5 text-indigo-600"}
              fill={"none"}
              viewBox={"0 0 24 24"}
            >
              <circle
                className={"opacity-25"}
                cx={"12"}
                cy={"12"}
                r={"10"}
                stroke={"currentColor"}
                strokeWidth={"4"}
              />
              <path
                className={"opacity-75"}
                fill={"currentColor"}
                d={
                  "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }
              />
            </svg>
            <span className={"text-indigo-600 text-xs sm:text-base font-medium"}>
              {"Redirecting..."}
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4"
      }
    >
      <div
        className={
          "bg-white rounded-xl sm:rounded-2xl shadow-2xl p-4 sm:p-8 md:p-10 w-full max-w-sm sm:max-w-md mx-auto relative"
        }
      >
        <div className={"text-center mb-4 sm:mb-8"}>
          <div className={"mx-auto flex items-center justify-center mb-4 sm:mb-6"}>
            <img src={"/Logo.webp"} className={"h-32 w-32"} alt={"code bro , codebruh"} />
          </div>
          <h2 className={"text-lg sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2 sm:mb-3"}>
            {"Verify Your Email"}
          </h2>
          <p className={"text-gray-600 text-xs sm:text-base leading-relaxed mb-1"}>
            {"We've sent a 6-digit verification code to"}
          </p>
          <p className={"font-semibold text-indigo-600 text-xs sm:text-base break-all"}>{M(n)}</p>
        </div>
        {c && (
          <div
            className={
              "bg-red-50 border border-red-200 text-red-700 px-3 py-2 sm:px-4 sm:py-3 rounded-lg mb-4 sm:mb-6"
            }
          >
            <div className={"flex items-start"}>
              <svg
                className={"w-4 h-4 sm:w-5 sm:h-5 mr-2 mt-0.5 flex-shrink-0"}
                fill={"currentColor"}
                viewBox={"0 0 20 20"}
              >
                <path
                  fillRule={"evenodd"}
                  d={
                    "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  }
                  clipRule={"evenodd"}
                />
              </svg>
              <span className={"text-xs sm:text-sm"}>{c}</span>
            </div>
          </div>
        )}
        <form onSubmit={A} className={"space-y-4 sm:space-y-6"}>
          <div>
            <label
              className={
                "block text-xs sm:text-sm font-medium text-gray-700 mb-3 sm:mb-4 text-center"
              }
            >
              {"Enter verification code"}
            </label>
            <VerifyOtpInput
              length={6}
              value={i}
              onChange={(Y) => {
                (l(Y), u(""));
              }}
              error={c}
            />
          </div>
          <button
            type={"submit"}
            disabled={m || i.length !== 6}
            className={
              "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-2.5 sm:py-4 px-4 sm:px-6 rounded-lg text-sm sm:text-base transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            }
          >
            {m ? (
              <div className={"flex items-center justify-center"}>
                <svg
                  className={"animate-spin -ml-1 mr-3 h-4 w-4 sm:h-5 sm:w-5 text-white"}
                  fill={"none"}
                  viewBox={"0 0 24 24"}
                >
                  <circle
                    className={"opacity-25"}
                    cx={"12"}
                    cy={"12"}
                    r={"10"}
                    stroke={"currentColor"}
                    strokeWidth={"4"}
                  />
                  <path
                    className={"opacity-75"}
                    fill={"currentColor"}
                    d={
                      "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    }
                  />
                </svg>
                {"Verifying..."}
              </div>
            ) : (
              "Verify Email"
            )}
          </button>
        </form>
        <div className={"text-center mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-100"}>
          <p className={"text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4"}>
            {"Didn't receive the code?"}
          </p>
          <button
            type={"button"}
            onClick={O}
            disabled={g > 0 || x}
            className={
              "inline-flex items-center justify-center px-3 sm:px-6 py-2 sm:py-3 border-2 border-indigo-200 text-indigo-600 rounded-lg hover:border-indigo-300 hover:bg-indigo-50 transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none text-xs sm:text-base font-medium"
            }
          >
            {g > 0 ? (
              <jsxRuntime.Fragment>
                <svg
                  className={"w-3 h-3 sm:w-5 sm:h-5 mr-1 sm:mr-2"}
                  fill={"none"}
                  stroke={"currentColor"}
                  viewBox={"0 0 24 24"}
                >
                  <circle cx={"12"} cy={"12"} r={"10"} strokeWidth={"2"} />
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={"M12 6v6l4 2"}
                  />
                </svg>
                {"Resend in "}
                {g}
                {"s"}
              </jsxRuntime.Fragment>
            ) : x ? (
              <jsxRuntime.Fragment>
                <svg
                  className={"animate-spin -ml-1 mr-1 sm:mr-2 h-3 w-3 sm:h-5 sm:w-5"}
                  fill={"none"}
                  viewBox={"0 0 24 24"}
                >
                  <circle
                    className={"opacity-25"}
                    cx={"12"}
                    cy={"12"}
                    r={"10"}
                    stroke={"currentColor"}
                    strokeWidth={"4"}
                  />
                  <path
                    className={"opacity-75"}
                    fill={"currentColor"}
                    d={
                      "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    }
                  />
                </svg>
                {"Sending..."}
              </jsxRuntime.Fragment>
            ) : (
              <jsxRuntime.Fragment>
                <svg
                  className={"w-3 h-3 sm:w-5 sm:h-5 mr-1 sm:mr-2"}
                  fill={"none"}
                  stroke={"currentColor"}
                  viewBox={"0 0 24 24"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={
                      "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    }
                  />
                </svg>
                {"Resend code"}
              </jsxRuntime.Fragment>
            )}
          </button>
        </div>
        <div className={"text-center mt-4 sm:mt-6"}>
          <p className={"text-xs text-gray-500 leading-relaxed"}>
            {"Check your spam folder if you don't see the email in your inbox"}
          </p>
        </div>
      </div>
    </div>
  );
};
export { VerifyEmailForm };
